/**
 * Enum for marker type, which determines the marker to use when drawing the chart
 * @readonly
 * @enum {string}
 */
export const markerType = Object.freeze({
	/** Draw indicator using bar markers */
	BAR: 'bar',
	/** Draw indicator using candlestick markers */
	CANDLESTICK: 'candlestick',
	/** Draw indicator using a line chart with a fill underneath the line */
	FILL: 'fill',
	/** Draw indicator using High-Low-Close markers */
	HLC: 'hlc',
	/** Draw indicator using lines connecting each data point */
	LINE: 'line',
	/** Draw indicator using lines connecting each data point, with a shape at each point on top of the line */
	LINEWITHSHAPES: 'lineWithShapes',
	/** Draw indicator using Open-High-Low-Close markers with colors specified by ohlcType */
	OHLC: 'ohlc',
	/** Draw indicator using positive/negative fill based on previous close */
	POSNEG: 'posneg',
	/** Draw indicator using shapes for each data point */
	SHAPE: 'shape',
	/** Draw indicator using stepped line markers */
	STEPPED: 'stepped'
});

/**
 * Enum for OHLC type, which determines how to render the OHLC marker
 * @readonly
 * @enum {string}
 */
export const ohlcType = Object.freeze({
	/** Draw using one color */
	MONO: 'mono',
	/** Draw new highs with positive color */
	NEWHIGHS: 'newhighs',
	/** Draw new lows with negative color */
	NEWLOWS: 'newlows',
	/** Draw using posneg logic */
	POSNEG: 'posneg'
});

export const shapeType = Object.freeze({
	CIRCLE: 'circle',
	CUSTOM: 'custom',
	DIAMOND: 'diamond',
	SQUARE: 'square',
	TRIANGLE: 'triangle'
});

export default {
	markerType,
	ohlcType,
	shapeType
};
